import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appNumberColor]'
})
export class NumberColorDirective implements OnChanges {
  @Input() appNumberColor = '';

  constructor(
    private ngElement: ElementRef<HTMLElement>,
    private ngRenderer: Renderer2,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.resetClass();

    this.ngElement.nativeElement.innerHTML = this.appNumberColor;

    const number = +((this.appNumberColor || '').replace(/,/gi, ''));

    if (typeof number === 'number') {
      if (number < 0) {
        this.addDangerClass();
      } else if (number > 0) {
        this.addSuccessClass();
      } else if (number == 0) {
        this.ngElement.nativeElement.classList.add('opacity-50');
      }
    }
  }

  addSuccessClass() {
    this.ngElement.nativeElement.classList.add('text-primary');
  }
  addDangerClass() {
    this.ngElement.nativeElement.classList.add('text-danger');
  }

  resetClass() {
    this.ngElement.nativeElement.classList.remove('text-primary')
    this.ngElement.nativeElement.classList.remove('text-danger');
    this.ngElement.nativeElement.classList.remove('opacity-50');
  }
}
